<template>
<div class="noPassAudit">
  <div
    v-if="userStatus == 3"
    class="content">
    <img
      class="img-el"
      src="../../assets/images/customer/noActive.png"
      alt=""
    >
    <p class="subtitle">{{$t('Register.unCheck')}}</p>
    <div class="active-code-btn">
      <vs-button
        @click="activeCodeHandle"
      >{{$t('Start_Activation')}}</vs-button>
    </div>
    <div class="email-active-btn">
      <el-button
        type="text"
        @click="sendActiveHandle"
      >{{$t('Register.sendEmail')}}</el-button>
    </div>
    <p v-if="isSend" class="center">{{$t('Activation_email_sent')}}</p>
  </div>
  <div
    v-if="userStatus == 4"
    class="content">
    <img class="img-el" src="../../assets/images/customer/noAuth.png" alt="">
    <p class="subtitle">{{$t('User.reportImgStatus')}}</p>
    <p class="tips">{{$t('To_verify_your_identity_information_please_prepare_your_ID_card_passport_and_ID_photo')}}</p>
    <vs-button
      @click="nowAuthHandle"
    >{{$t('Authenticate_now')}}</vs-button>
  </div>
  <div
    v-if="userStatus == 1"
    class="content">
    <img class="img-el" src="../../assets/images/customer/infoAuthing.png" alt="">
    <p class="subtitle">{{$t('User.checking')}}</p>
    <p class="tips">{{$t('The_estimated_review_time_is_1_3_working_days_please_be_patient')}}</p>
  </div>
  <div
    v-if="userStatus == 2"
    class="content">
    <img class="img-el" src="../../assets/images/customer/auditFail.png" alt="">
    <p class="subtitle">{{$t('Data_review_failed')}}</p>
    <p class="tips">{{$t('infoRejectTips')}}</p>
    <vs-button
      @click="recertificateHandle"
    >{{$t('recertification')}}</vs-button>
  </div>
  <active-code-dialog
    ref="activedialog"
  ></active-code-dialog>
</div>
</template>

<script>
import activeCodeDialog from "@/components/dashboard/activeCodeDialog";
import { retryRegActiveEmail } from '@/api/user.js'
import { mapGetters } from 'vuex'
export default {
  name: "noPassAudit",
  components: {
    activeCodeDialog
  },
  props: {
    userStatus: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      isSend: false,
      activeCodeDialogShow: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    activeCodeHandle(){
      this.$refs.activedialog.dialogShow = true;
    },
    sendActiveHandle() {
      let params = {
        custId:this.userInfo.id
      }
      retryRegActiveEmail(params).then((result) => {
        this.isSend = true;
        this.$vs.notify({
          title: this.$t('Email_sent'),
          text:`${this.$t('Please_check_your_email')}: ${this.userInfo.email},${this.$t('and_activate')}`,
          position:'top-right'
        })
        /*this.isSend=true;
        this.$message({
          message: this.$t('Register.successTips5'),
          type: 'success'
        })*/
      }).catch((err) => {

      });

    },
    nowAuthHandle(){
      this.$router.push({name: 'perfectInfo'});
    },
    //
    recertificateHandle(){
      this.$router.push({name: 'perfectInfo'});
    }
  },
}
</script>

<style lang="scss" scoped>
.noPassAudit {
  background-color: #fff;
  min-height: 500px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .img-el {
    width: 120px;
    height: 120px;
  }
  .content {
    text-align: center;
    .subtitle {
      font-size: 24px;
      font-weight: 600;
      margin: 16px 0;
    }
    .tips {
      margin: 16px 0;
    }
  }
  .email-active-btn {
    padding-top: 10px;
  }
}
</style>
